import React from 'react'
import styled from 'styled-components'
import classNames from 'classnames'

import DynamicLinkField from './DynamicLinkField'
import DynamicLinkQRcode from './DynamicLinkQRcode'
import withGenerateQRHandler from './withGenerateQRHandler'

const DynamicLinkView = ({
  title,
  url,
  qrCode,
  onGenerateQRPortal,
  isLoading,
}) => (
  <Card>
    <p className="title"> {title} </p>
    <p className="subtitle">
      <DynamicLinkField url={url} />
    </p>
    <Line />
    {qrCode ? (
      <DynamicLinkQRcode qrCodeImageURL={qrCode} />
    ) : (
      <DynamicLinkEmpty
        onGenerateQR={onGenerateQRPortal}
        isLoading={isLoading}
      />
    )}
  </Card>
)

const DynamicLinkEmpty = ({ onGenerateQR, isLoading }) => (
  <DynamicLinkEmptyLayout>
    <p className="has-text-centered"> คลิกที่นี่เพื่อสร้าง QR CODE </p>
    <button
      className={classNames('button is-primary', { 'is-loading': isLoading })}
      onClick={onGenerateQR}
    >
      Create QR CODE
    </button>
  </DynamicLinkEmptyLayout>
)

const DynamicLinkEmptyLayout = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Line = styled.hr`
  margin: 0.5rem 0 !important;
`

const Card = styled.div.attrs({
  className: 'card section',
})`
  @media only screen and (min-width: 1000px) {
    width: 35vw;
  }
  height: 100%;
  display: flex;
  flex-direction: column;
`

export default withGenerateQRHandler(DynamicLinkView)



// WEBPACK FOOTER //
// ./src/components/templates/dynamic-link/DynamicLinkView.js